import { createFileRoute } from '@tanstack/react-router';
import { useParams } from '@tanstack/react-router';

import { Loader } from '@/components/Loading';
import { Text } from '@/components/Typography';
import { Dialog } from '@/components/ui/dialog';
import { ApprovalTaskDetailDialogContent } from '@/features/boe-task/components/ApprovalTaskDetail/ApprovalTaskDetailDialogContent';
import { useTranslation } from '@/lib/i18n';

import { useDetailDialog } from '../../-hooks/useDetailDialog';

import { useApprovalActions } from './-hooks/useApprovalActions';
import { useApprovalTaskDetailQuery } from './-query/useApprovalTaskDetailQuery';
import { mapApprovalFlowToApprovers } from './-utils/approvalFlowMapper';

export const Route = createFileRoute('/_staff/cockpit/approval/$id/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = useParams({ from: '/_staff/cockpit/approval/$id/' });
  const { data, isLoading, error } = useApprovalTaskDetailQuery(id);
  const { approve, reject } = useApprovalActions();
  const { open, setOpen } = useDetailDialog();
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.cockpit.detail',
  });

  // ローディング中
  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader />
      </div>
    );
  }

  // エラー
  if (error || !data) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Text variant="p" className="text-red-600">
          {t('error')}
        </Text>
      </div>
    );
  }

  // 現在のステージを計算（PendingApprovalのステップを探す）
  const currentStep = data.approvalFlow.find(
    (step) => step.status === 'PendingApproval',
  );

  return (
    <>
      <Dialog open={open} onOpenChange={setOpen}>
        <ApprovalTaskDetailDialogContent
          taskStatus="InProgress"
          taskType="Approval"
          taskName={data.approvalTaskCatalogName}
          taskTarget={data.target?.name}
          targetSubordinate={data.target?.description}
          description={data.approvalTaskCatalogDescription}
          progress={
            currentStep
              ? {
                  current: currentStep.order,
                  total: data.approvalFlow.length,
                }
              : undefined
          }
          approvers={mapApprovalFlowToApprovers(data.approvalFlow)}
          submitTaskForm={data.submitTaskForm}
          onApprove={async () => {
            await approve(id);
            setOpen(false);
          }}
          onReject={async () => {
            await reject(id);
            setOpen(false);
          }}
          onReturn={() => {
            setOpen(false);
          }}
        />
      </Dialog>
    </>
  );
}
